import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { asyncLanguagesAndCountryCodesFetch } from '../async/asyncI18n';

import { languageAndCountryCodesAtom } from '$atoms/i18n-atoms';
import { useTranslate } from '$hooks/useTranslate';

export function useLanguageAndCountryCodes() {
    const { locale } = useTranslate();

    const [languageAndCountryCodes, setLanguageAndCountryCode] = useAtom(
        languageAndCountryCodesAtom
    );

    useEffect(() => {
        if (languageAndCountryCodes.length === 0)
            asyncLanguagesAndCountryCodesFetch(locale).then(setLanguageAndCountryCode);
    }, [locale]);

    return languageAndCountryCodes;
}
